export default __webpack_public_path__ + "static/media/NLR-1.41925ab9.webp";